import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const usePlansStore = create()(
    persist(
        (set) => ({
            refetchPlans: false,
            storeRefetchPlans: (refetchPlans) => set(() => ({ refetchPlans: refetchPlans })),
            shouldBlockNewPOS: false,
            storeShouldBlockNewPos: (shouldBlockNewPOS) => set(() => ({ shouldBlockNewPOS })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'plans-storage'
        }
    )
);

export default usePlansStore;